/**
 * D5 — a etiqueta da categoria: badge neutro com o ponto na cor da categoria. O NOME vai
 * escrito (cor não é canal único) e a cor sai de token `chart-N`.
 */
import { Badge, cn } from '@mgdlead/ui';

import {
  CATEGORY_COLOR_NAME,
  CATEGORY_DOT,
  type CategoryColor,
} from '../../../features/group/category-ui';

export interface CategoryBadgeProps {
  name: string;
  color: CategoryColor;
  className?: string;
}

export function CategoryBadge({ name, color, className }: CategoryBadgeProps) {
  return (
    <Badge
      tone="outline"
      className={className}
      title={`Categoria: ${name} (${CATEGORY_COLOR_NAME[color]})`}
      icon={<span className={cn('block size-2 rounded-full', CATEGORY_DOT[color])} />}
    >
      {name}
    </Badge>
  );
}
